<template>
<table-template ref="usedCarLinkTable" actionUrl="privateUsedCar/findUsedCarLinkList.action" :queryParams="queryParams">
    <template slot="search">
      <el-select  v-model="queryParams.state" :clearable="true" @change="$refs['usedCarLinkTable'].search()">
        <el-option :value="1" label="启用"></el-option>
        <el-option :value="2" label="停用"></el-option>
      </el-select>
      <el-date-picker
        style="margin-left:10px;"
        v-model="queryParams.startEndTime"
        @change="onDateTimeChange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-input v-model="queryParams.keyword" style="margin-left:10px;width:230px;" placeholder="请输入渠道名称/姓名/电话"></el-input>
      <el-button style="margin-left:10px;" type="primary" @click="$refs['usedCarLinkTable'].search()">搜索</el-button>
      <el-button  @click="$router.push('saveUsedCarLink')">新增</el-button>
    </template>
    <template slot="item">
      <el-table-column prop="id" label="编号" width="80px">
      </el-table-column>
      <el-table-column  label="渠道信息" width="180px">
        <template scope="scope">
          <p>{{scope.row.linkName}}</p>
          <p>{{scope.row.contactsName}} {{scope.row.phone}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="link" label="渠道链接" width="250px">
      </el-table-column>
        <el-table-column prop="shortLink" label="短链接" width="250px">
        </el-table-column>
      <el-table-column label="状态">
        <template scope="scope">
          <p v-bind:style="{color:getColor(scope.row.state)}">{{scope.row.state==1?'启用':'停用'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="总PV/UV（每晚22:00更新）">
        <template scope="scope">
          <p>{{scope.row.pvCumulativeCount}} / {{scope.row.uvCumulativeCount}}</p>
        </template>
      </el-table-column>
      <el-table-column label="月PV/UV（每晚22:00更新）">
        <template scope="scope">
          <p>{{scope.row.pvMonthCount}} / {{scope.row.uvMonthCount}}</p>
        </template>
      </el-table-column>
      <el-table-column label="总车源条数">
          <template scope="scope">
              <p>{{scope.row.usedCarAllCount}}</p>
          </template>
      </el-table-column>
      <el-table-column label="本月车源条数">
          <template scope="scope">
              <p>{{scope.row.usedCarMonthCount}}</p>
          </template>
      </el-table-column>
      <el-table-column label="累计收入">
          <template scope="scope">
              <p>{{scope.row.cumulativeForMoney/100}} 元</p>
          </template>
      </el-table-column>
      <el-table-column label="本月收入">
          <template scope="scope">
              <p>{{scope.row.monthForMoney/100}} 元</p>
          </template>
      </el-table-column>
      <el-table-column label="今日收入">
          <template scope="scope">
              <p>{{scope.row.dayForMoney/100}} 元</p>
          </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template scope="scope">
          <p>{{scope.row.createTime|dateTimeFormat}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-button v-if="scope.row.state==1" confirm-text="确定停用该链接？" :confirm-data="{id:scope.row.id,status:2}" @onConfirm="$refs['usedCarLinkTable'].search()" requestUrl="/privateUsedCar/changeUserCarLinkStatus.action" v-confirm type="text">停用</el-button>
          <el-button v-else confirm-text="确定启用该链接？" :confirm-data="{id:scope.row.id,status:1}" @onConfirm="$refs['usedCarLinkTable'].search()" requestUrl="/privateUsedCar/changeUserCarLinkStatus.action" v-confirm type="text">启用</el-button>
          <el-button type="text" @click="$router.push('saveUsedCarLink/'+scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>
    </template>
  </table-template>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  components: {
    TableTemplate
  },
  data () {
    return {
      queryParams: {}
    }
  },
  methods: {
    getColor (state) {
      return state === 1 ? '#000' : '#F56C6C'
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs['usedCarLinkTable'].search()
    }
  }
}
</script>
